import apiClient from '../../../utils/lib/apiClient'
import { loadingState, loadingText } from '../../../states/loadingState'
import { useSetRecoilState } from 'recoil'
import { useCallback } from 'react'
export const useGetDiraryListWithDateRange = () => {
  const setLoadingAnimation = useSetRecoilState(loadingState)
  const setLoadingText = useSetRecoilState(loadingText)

  const getDiaryListByWokerAndDays = useCallback(
    async (
      workerNo: string,
      fromDate: string,
      toDate: string,
      productNo: string,
      productBno: string
    ) => {
      setLoadingAnimation(true)
      setLoadingText('取得中...')
      try {
        const res = await apiClient.get(
          `/siteDiary/posts/getDiaryByWorkerAndDays/${Number(
            workerNo
          )}/${fromDate}/${toDate}`,
          {
            params: {
              productNo: productNo || undefined,
              productBno: productBno || undefined,
            },
          }
        )
        const data = res.data
        return data
      } catch (e) {
        window.alert('エラーが発生しました' + e)
        return null
      } finally {
        setLoadingAnimation(false)
        setLoadingText('')
      }
    },
    [loadingState, loadingText]
  )

  const getDiaryListByWokerAndDaysWithHoliday = useCallback(
    async (
      workerNo: string,
      fromDate: string,
      toDate: string,
      productNo: string,
      productBno: string
    ) => {
      setLoadingAnimation(true)
      setLoadingText('取得中...')
      try {
        const res = await apiClient.get(
          `/siteDiary/posts/getDiaryByWorkerAndDays/withHoliday/${Number(
            workerNo
          )}/${fromDate}/${toDate}`,
          {
            params: {
              productNo: productNo || undefined,
              productBno: productBno || undefined,
            },
          }
        )
        const data = res.data
        return data
      } catch (e) {
        window.alert('エラーが発生しました' + e)
        return null
      } finally {
        setLoadingAnimation(false)
        setLoadingText('')
      }
    },
    [loadingState, loadingText]
  )

  return { getDiaryListByWokerAndDays, getDiaryListByWokerAndDaysWithHoliday }
}
